
export class Usuario {

        public S00USR:   string;
		public PAD10AP1: string;
		public PAD10AP2: string;
        public PAD10NOM: string;
		public PAD10TIP: string;
		public PAD10CED: string;
        public S00EMA:   string;
        public M12TE1:   string;
        public M12TE2:   string;
        public M12DIR:   string;
        public S00CLA:   string;
        public S00CLA_2: string;
        public M12CAR:   string;
        public S00NOM:   string;
        public PAD10COD: string;
}

